import { render, staticRenderFns } from "./set-role.vue?vue&type=template&id=56359360&scoped=true&"
import script from "./set-role.vue?vue&type=script&lang=js&"
export * from "./set-role.vue?vue&type=script&lang=js&"
import style0 from "./set-role.vue?vue&type=style&index=0&id=56359360&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56359360",
  null
  
)

export default component.exports